import React from 'react';
import { useTheme } from '../../context/shared/ThemeContext'

const TokenPurchase: React.FC = () => {
  const { themeClasses } = useTheme();
  
  return (
    <div className={`${themeClasses.secondaryCardBg} rounded-lg p-6 space-y-6`}>
      <h2 className={`text-xl font-semibold ${themeClasses.primaryText}`}>Purchase More Tokens</h2>
      
      <div className={`${themeClasses.cardBg} rounded-lg p-4 text-center`}>
        <p className={`text-lg font-medium ${themeClasses.primaryText}`}>Balance: 0 tokens</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Wellness Package */}
        <div className={`${themeClasses.cardBg} rounded-lg p-4 text-center`}>
          <div className="text-green-400 text-2xl mb-2">🌱</div>
          <h3 className={`text-lg font-medium ${themeClasses.primaryText} mb-1`}>Wellness</h3>
          <p className={`text-2xl font-bold ${themeClasses.primaryText} mb-1`}>~1.1 hours</p>
          <p className={`text-sm ${themeClasses.mutedText} mb-4`}>of conversation time</p>
          <p className={`text-xl font-bold ${themeClasses.primaryText} mb-1`}>$5.00</p>
          <p className={`text-xs ${themeClasses.mutedText} mb-4`}>Perfect for daily check-ins</p>
          <button className="w-full py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md font-medium transition-colors">
            Purchase
          </button>
        </div>

        {/* Growth Package */}
        <div className={`${themeClasses.cardBg} rounded-lg p-4 text-center relative`}>
          <div className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-bold">
            SAVE 10%
          </div>
          <div className="text-blue-400 text-2xl mb-2">🌿</div>
          <h3 className={`text-lg font-medium ${themeClasses.primaryText} mb-1`}>Growth</h3>
          <p className={`text-2xl font-bold ${themeClasses.primaryText} mb-1`}>~3.3 hours</p>
          <p className={`text-sm ${themeClasses.mutedText} mb-4`}>of conversation time</p>
          <div className="mb-2">
            <span className={`text-lg line-through text-gray-400`}>$15.00</span>
            <span className={`text-xl font-bold ${themeClasses.primaryText} ml-2`}>$13.50</span>
          </div>
          <p className={`text-xs ${themeClasses.mutedText} mb-4`}>Ideal for weekly sessions</p>
          <button className="w-full py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md font-medium transition-colors">
            Purchase
          </button>
        </div>

        {/* Flourish Package */}
        <div className={`${themeClasses.cardBg} rounded-lg p-4 text-center relative`}>
          <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold">
            SAVE 20%
          </div>
          <div className="text-purple-400 text-2xl mb-2">🌸</div>
          <h3 className={`text-lg font-medium ${themeClasses.primaryText} mb-1`}>Flourish</h3>
          <p className={`text-2xl font-bold ${themeClasses.primaryText} mb-1`}>~6.6 hours</p>
          <p className={`text-sm ${themeClasses.mutedText} mb-4`}>of conversation time</p>
          <div className="mb-2">
            <span className={`text-lg line-through text-gray-400`}>$30.00</span>
            <span className={`text-xl font-bold ${themeClasses.primaryText} ml-2`}>$24.00</span>
          </div>
          <p className={`text-xs ${themeClasses.mutedText} mb-4`}>Best for intensive support</p>
          <button className="w-full py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md font-medium transition-colors">
            Purchase
          </button>
        </div>
      </div>

      <div className={`${themeClasses.cardBg} rounded-lg p-4 text-center space-y-2`}>
        <p className={`text-sm font-medium ${themeClasses.primaryText}`}>Volume Discounts: Save more with larger packages</p>
        <p className={`text-xs ${themeClasses.mutedText}`}>Conversation time never expires and supports your mental wellness journey.</p>
      </div>
    </div>
  );
};

export default TokenPurchase; 